export default __webpack_public_path__ + "static/media/dianoiva_5.312f0dd8.jpg";